import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { downloadFile, formatApiError } from "../context/AuthContext";
import { Button } from "./ui/button";
import { Checkbox } from "./ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { toast } from "sonner";

const STATUTS_EXPORT = [
  { value: "valide", label: "Valides" },
  { value: "a_recycler", label: "À recycler / à renouveler" },
  { value: "depasse", label: "Dépassés / expirés" },
  { value: "non_forme", label: "Non formés" },
];

export default function ExportDialog({ type, filename, extraParams = "", testid, className = "", variant = "outline", initialStatuts }) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(initialStatuts || ["valide", "a_recycler", "depasse", "non_forme"]);
  const [downloading, setDownloading] = useState(false);

  const toggle = (v) => setSelected((s) => (s.includes(v) ? s.filter((x) => x !== v) : [...s, v]));

  const run = async () => {
    setDownloading(true);
    try {
      await downloadFile(`/export/excel?type=${type}&statuts=${selected.join(",")}${extraParams}`, filename);
      toast.success("Export Excel téléchargé");
      setOpen(false);
    } catch (e) {
      toast.error(formatApiError(e, "Export impossible"));
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <Button variant={variant} className={className} onClick={() => setOpen(true)} data-testid={testid}>
        <Download className="h-4 w-4 mr-2" /> Export Excel
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid={`${testid}-dialog`}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Download className="h-5 w-5 text-accent" /> Exporter en Excel</DialogTitle>
            <DialogDescription>Choisissez les statuts à inclure dans le fichier.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3 py-2" data-testid={`${testid}-statuts`}>
            {STATUTS_EXPORT.map((o) => (
              <label key={o.value} className="flex items-center gap-3 text-sm cursor-pointer">
                <Checkbox checked={selected.includes(o.value)} onCheckedChange={() => toggle(o.value)} data-testid={`${testid}-statut-${o.value}`} />
                {o.label}
              </label>
            ))}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Annuler</Button>
            <Button onClick={run} disabled={downloading || selected.length === 0} data-testid={`${testid}-confirm`}>
              {downloading ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Téléchargement...</> : <><Download className="h-4 w-4 mr-2" /> Télécharger</>}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
